import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button, LinearProgress, Dialog, DialogTitle, DialogContent, DialogActions, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Paper } from '@mui/material';
import UndoIcon from '@mui/icons-material/Undo';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import HomeIcon from '@mui/icons-material/Home';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import EventIcon from '@mui/icons-material/Event';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { makeStyles } from '@mui/styles';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import useServices from '../services/useServices';
import moment from 'moment';
const useStyles = makeStyles(() => ({
  root: {
    borderRadius: '5px',
    padding: '10px',
    '& .requested .MuiStepIcon-root': { color: '#cc0000' },
    '& .accepted .MuiStepIcon-root': { color: '#e06666' },
    '& .onroute .MuiStepIcon-root': { color: '#e69138' },
    '& .arrived .MuiStepIcon-root': { color: '#009e0f' },
    '& .disabled .MuiStepIcon-root': { color: 'grey' },
  },
  noteSection: {
    padding: '10px',
    backgroundColor: '#f0f0f0',
    borderRadius: '5px',
    marginTop: '20px',
    position: 'relative',
  },
  noteField: {
    width: '100%',
  },
  stepLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '1px',
    position: 'relative',
  },
  header: {
    backgroundColor: '#e69138', // Orange color
    color: '#fff',
    padding: '5px 40px', // Increased padding for more prominence
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '18px', // Increased font size for prominence
    width: '80%', // Occupy more space
    borderRadius: '10px', // Rounded corners
    position: 'relative',
    top: '-10px',
  },
  locationSection: {
    margin: '20px 0',
  },
  locationField: {
    margin: '10px 0',
  },
  vehicleSection: {
    margin: '20px 0',
    backgroundColor: '#f0f0f0',
    padding: '10px',
    borderRadius: '5px',
  },
  vehicleField: {
    display: 'flex',
    alignItems: 'center',
    margin: '10px',
  },
  invoiceSection: {
    margin: '20px 0',
  },
  statusSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '20px',
    padding: '10px',
    backgroundColor: '#f0f0f0',
    borderRadius: '5px',
    overflowX: 'auto',
  },
  statusItem: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '20px',
  },
  statusHeader: {
    color: '#000',
    padding: '5px 40px', // Increased padding for more prominence
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '24px', // Increased font size for prominence
    width: '80%', // Occupy more space
    borderRadius: '10px', // Rounded corners
    marginBottom: '10px',
    position: 'relative',
  },
  undoButton: {
    marginLeft: '10px',
  },
  progressBar: {
    width: '150px', // Adjusted width of the progress bar
    height: '10px',
    backgroundColor: '#666',
    marginLeft: '10px',
    marginRight: '10px',
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: 'green',
    },
  },
  customIndicator: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: 'green',
    marginRight: '10px',
    cursor: 'pointer', // To indicate clickable element
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Center the label and time
    marginRight: '10px',
  },
  pictureSection: {
   margin:'10px 50px',
    textAlign: 'center',
  },
  picture: {
    width: '150px',
    height: '300px',
  },
  notesSection: {
    margin: '20px 0',
    position: 'relative',
  },
  addNoteButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
  }
}));

function TrackingComponent({ steps, isLoading, invoiceId, onRevertCall,data }) {
  const classes = useStyles();
  const [notes, setNotes] = useState(data.notes||[]);
  const [selectedStep, setSelectedStep] = useState(steps.length ? steps[0].label : '');
  const [openModal, setOpenModal] = useState(false);
  const [openAddNoteModal, setOpenAddNoteModal] = useState(false);
  const [newNote, setNewNote] = useState('');
  const { put,post } = useServices();

  const formatTime = (timestamp) => {
    if (!timestamp) {
      return "--:--";
    }
  
    const time = moment(timestamp, "HH:mm:ss MM/DD/YYYY");
  
    if (!time.isValid()) {
      return "--:--";
    }
  
    return time.format('HH:mm');
  };

  const getProgressBarColor = (step, nextStep) => {
    if (step.description && nextStep.description) {
      return 'primary'; // Green if both timestamps are available
    }
    return 'inherit'; // Black otherwise
  };

  const handleStepClick = (stepLabel) => {
    setSelectedStep(stepLabel);
  };

  const revertToEnroute = async () => {
    try {
      const response = await put(`newservicecall/directCall/${invoiceId}/revertToEnroute`);
      if (response.status === 200) {
        alert(response.data);
        onRevertCall();
      } else {
        alert(response.data);
      }
    } catch (error) {
      console.log(error);
      alert(error.response.data);
    }
  };

  const handleAddNote = async () => {
    // const newNoteEntry = {
    //   userId: 'officer', // Replace with actual user ID
    //   notesDate: new Date().toISOString().split('T')[0],
    //   notesTime: new Date().toLocaleTimeString(),
    //   notesData: newNote,
    //   invoiceId: invoiceId,
    //   notesIndicator: 2
    // };
    const newNoteEntry = {
      allRecords: null,
      invoiceId: invoiceId,
      notesData: newNote,
      notesDate: new Date().toISOString().split('T')[0],
      notesId: null, // to be set by backend
      notesIndicator: 0,
      notesTime: new Date().toLocaleTimeString(),
      pageSize: 0,
      pageStartIndex: 0,
      totalInvoiceNoteCount: null,
      userId: 'user123' // Replace with actual user ID
    };
    
    try {
      const response = await post('newservicecall/directCall/addNote', newNoteEntry);
      if (response.status === 200) {
        alert('Note added successfully');
        // Optionally, update the local state to reflect the new note
        newNoteEntry['notesId']=response.data;
        setNotes([...notes, newNoteEntry]);
        setNewNote('');
        setOpenAddNoteModal(false);
      } else {
        alert('Failed to add note');
      }
    } catch (error) {
      console.error(error);
      alert('Error adding note');
    }
  };

  return (
    <Box className={classes.root}>
      {data.flatbedNeeded?<div className={classes.headerContainer}>
        <div className={classes.header}>
          Flatbed Request
        </div>
      </div>:null}
      <div className={classes.invoiceSection}>
        <Box display="flex" alignItems="center">
          <ReceiptIcon color="primary" />
          <Typography variant="body1" style={{ marginLeft: '8px' }}>
            <strong>Invoice ID:</strong> {invoiceId}
          </Typography>
        </Box>
      </div>
      <div className={classes.locationSection}>
        <Box display="flex" alignItems="center" className={classes.locationField}>
          <LocalShippingIcon color="secondary" />
          <Typography variant="body1" style={{ marginLeft: '8px' }}>
            <strong>Pickup Location:</strong> {data.pickup}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" className={classes.locationField}>
          <HomeIcon color="success" />
          <Typography variant="body1" style={{ marginLeft: '8px' }}>
            <strong>Drop Location:</strong> {data.dropoff}
          </Typography>
        </Box>
      </div>
      <div className={classes.vehicleSection}>
        <Typography variant="h6" gutterBottom>
          Vehicle Information
        </Typography>
        <Box display="flex" flexWrap="wrap">
          <Box className={classes.vehicleField}>
            <VpnKeyIcon color="primary" />
            <Typography variant="body1" style={{ marginLeft: '8px' }}>
              <strong>VIN:</strong> {data.vin||''}
            </Typography>
          </Box>
          <Box className={classes.vehicleField}>
            <EventIcon color="secondary" />
            <Typography variant="body1" style={{ marginLeft: '8px' }}>
              <strong>Year:</strong> {data.year||''}
            </Typography>
          </Box>
          <Box className={classes.vehicleField}>
            <DirectionsCarIcon color="success" />
            <Typography variant="body1" style={{ marginLeft: '8px' }}>
              <strong>Make:</strong> {data.make||''}
            </Typography>
          </Box>
          <Box className={classes.vehicleField}>
            <DirectionsCarIcon color="warning" />
            <Typography variant="body1" style={{ marginLeft: '8px' }}>
              <strong>Model:</strong> {data.model||''}
            </Typography>
          </Box>
        </Box>
      </div>
      <div className={classes.headerContainer}>
        <div className={classes.statusHeader}>
          Status
        </div>
      </div>
      <div className={classes.statusSection}>
        {steps.map((step, index) => (
          <Box key={index} className={classes.statusItem}>
            <div
              className={classes.customIndicator}
              style={{ backgroundColor: selectedStep === step.label ? 'blue' : 'green' }}
              onClick={() => handleStepClick(step.label)}
            />
            <Box className={classes.labelContainer}>
              <Typography variant="body2"><strong>{step.label}</strong></Typography>
              <Typography variant="body2">{formatTime(step.description)}</Typography>
              {step.description !== null && step.class === "arrived" && (
                <Button
                  startIcon={<UndoIcon />}
                  size="small"
                  variant="outlined"
                  color="primary"
                  className={classes.undoButton}
                  onClick={() => setOpenModal(true)}   // Open the modal when the button is clicked
                >
                  Undo
                </Button>
              )}
            </Box>
            {index < steps.length - 1 && (
              <LinearProgress
                className={classes.progressBar}
                color={getProgressBarColor(step, steps[index + 1])}
                variant="determinate"
                value={100}
              />
            )}
          </Box>
        ))}
      </div>
      <div className={classes.pictureSection}>
        <Typography variant="h6" gutterBottom>
          Pictures
        </Typography>
        <Carousel showArrows={true} showThumbs={false} infiniteLoop={true} dynamicHeight={false}>
          {data.pic.map((url, index) => (
            <div key={index}>
              <img src={url} alt={`Dummy ${index}`} className={classes.picture} />
            </div>
          ))}
        </Carousel>
      </div>
      <div className={classes.notesSection}>
        <Typography variant="h6" gutterBottom>
          Notes
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className={classes.addNoteButton}
          onClick={() => setOpenAddNoteModal(true)}
        >
          Add Note
        </Button>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Note ID</TableCell>
                <TableCell>Date/Time</TableCell>
                <TableCell>Note</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {notes.map((note) => (
                <TableRow key={note.notesId}>
                  <TableCell>{note.notesId}</TableCell>
                  <TableCell>{note.notesDate} {note.notesTime}</TableCell>
                  <TableCell>{note.notesData}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {/* Modal/Dialog to confirm undo or cancellation */}
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>Confirm Action</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to revert the status?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              revertToEnroute();
              setOpenModal(false);  // Close the modal after handling
            }}
            color="primary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {/* Modal/Dialog to add a note */}
      <Dialog open={openAddNoteModal} onClose={() => setOpenAddNoteModal(false)}>
        <DialogTitle>Add Note</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Note"
            type="text"
            fullWidth
            value={newNote}
            onChange={(e) => setNewNote(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAddNoteModal(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleAddNote} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default TrackingComponent;
